import React, { useEffect } from 'react'
import { Outlet, useParams } from 'react-router-dom'
import { useProjectStore } from '../stores/projectStore'
import { getProject } from '../lib/api'

export const ProjectWorkflowLayout: React.FC = () => {
  const { projectId } = useParams<{ projectId: string }>()
  const { setProject, reset } = useProjectStore()

  // Sync URL projectId with store and load project data
  useEffect(() => {
    if (!projectId) {
      return
    }

    const storeProjectId = useProjectStore.getState().projectId

    // If projectId changed, load the new project data
    if (storeProjectId !== projectId) {
      // Reset store first
      reset()

      // Load project data from API
      getProject(projectId).then((result) => {
        if (result.success && result.data) {
          // Use setProject to set all project data at once
          setProject(result.data)
        }
      }).catch((err) => {
        console.error('[ProjectWorkflowLayout] Failed to load project:', err)
      })
    }
  }, [projectId, setProject, reset])

  return (
    <div className="max-w-6xl mx-auto">
      {/* Step Content */}
      <div className="bg-surface-2 rounded-lg p-6">
        <Outlet />
      </div>
    </div>
  )
}

export default ProjectWorkflowLayout
